import Request from "../../../gd/data/request";

export default class ApiSlackNew {


    static get connectUrl() {
        return '/api/app/company/integrations/slack/connect?cid={0}'.f(gd.companyId)
    }

    static connectedChannels() {
        return new Request(this,'GET','company/integrations/slack/connected-channels');
    }

    static connectChannel(projectId: ID, channelId: ID, properties: any) {
        return new Request(this,'POST','company/integrations/slack/connected-channels',{
            projectId, channelId, properties
        });
    }

    static disconnect() {
        return new Request(this,'GET','company/integrations/slack/disable');
    }

    static listChannels() {
        return new Request(this,'GET','company/integrations/slack/list-channels');
    }

    static deleteConnectedChannel(projectId: ID, channelId: ID) {
        return new Request(this,'DELETE','company/integrations/slack/connected-channel/{0}/{1}'.f(projectId, channelId))
    }

    // static connect() {
    //     return new Request(this,'GET','company/integrations/slack/connect');
    // }

}
